import { OperationAccess } from "../enums/operation-access-enum";

export class AuthorizedOperations {
    operationAccess : OperationAccess = OperationAccess.None
    operations: string[] = [];
}